import React from 'react';
import { Award, Shield, CheckCircle2, Building } from 'lucide-react';

const Partners = () => {
  const certifications = [
    {
      icon: Award,
      title: 'ISO 9001:2015',
      description: 'Quality Management System'
    },
    {
      icon: Shield,
      title: 'ISO 14001:2015',
      description: 'Environmental Management'
    },
    {
      icon: CheckCircle2,
      title: 'ISO 45001:2018',
      description: 'Occupational Health & Safety'
    },
    {
      icon: Building,
      title: 'MNRE Approved',
      description: 'Ministry Recognition'
    }
  ];

  const partners = [
    'Tier-1 Solar Module Manufacturers',
    'Leading Inverter Technology Providers',
    'International EPC Contractors',
    'State DISCOMs & Power Utilities',
    'Financial Institutions & Banks',
    'Environmental Consultants'
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Partners & Certifications</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Working with industry leaders and maintaining highest quality standards
          </p>
        </div>

        {/* Certifications */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Our Certifications</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 text-center group"
              >
                <div className="w-16 h-16 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-emerald-100 transition-colors duration-300">
                  <cert.icon className="w-8 h-8 text-emerald-700" />
                </div>
                <h4 className="font-bold text-gray-900 mb-2">{cert.title}</h4>
                <p className="text-sm text-gray-600">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Partners */}
        <div className="bg-white rounded-2xl p-12 border border-gray-100 shadow-sm">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Strategic Partners</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {partners.map((partner, index) => (
              <div 
                key={index}
                className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl hover:bg-emerald-50 transition-colors duration-300"
              >
                <div className="w-2 h-2 bg-emerald-600 rounded-full flex-shrink-0" />
                <span className="text-gray-700 font-medium">{partner}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Trust Banner */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-emerald-50 rounded-2xl px-8 py-6 border border-emerald-100">
            <p className="text-lg text-gray-700">
              <span className="font-bold text-emerald-800">Trusted by government bodies,</span> financial institutions, and industry partners for delivering quality solar infrastructure
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
